import React from 'react';
import { useGlobal } from 'reactn';
import { formatCurrencyNum, formatDate } from '../../../helpers';
import ChevronIcon from '../../assets/small-link-chevron-gray.png';
import DownloadIcon from '../../assets/download-icon-blue.svg';
import Card from '../../common/card/Card';

const PastPayments = ({ ...rest }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (selectedServiceAccount === undefined) {
    return <h4>SERVICE ACCOUNT UNAVAILABLE</h4>;
  }
  const { pastPaymentData } = selectedServiceAccount;
  return (
    <Card
      title="Past Payments"
      titleLink="View All Past Bills >"
      titleLinkTo="/user/past-bills"
      titleLinkClassName="text-xs ml-10 text-right text-white normal-case"
      {...rest}
    >
      {pastPaymentData && pastPaymentData.length === 0 && (
        <div>No data available</div>
      )}
      {pastPaymentData &&
        pastPaymentData
          .filter((_, index) => index < 4)
          .map((p, idx) => {
            return (
              <div
                key={idx}
                className="border-b py-2 w-full last:border-0"
              >
                <span className="font-bold">{`${formatCurrencyNum(
                  p.AMOUNT
                )}`}</span>
                <span>{` paid on ${formatDate(p.PAYMENT_DATE)}`}</span>
              </div>
            );
          })}
    </Card>
  );
};

export default PastPayments;
